import type { MissionFilterId } from '../constants/status'
import { isMissionActionable } from './missionUiStatus'

/** Só o que a correspondência precisa — nada de tipo arrastando cadeia de UI. */
export type MissionMatchable = {
  uiStatus: string
  isNew: boolean
  isRecommended: boolean
  isEndingSoon: boolean
}

/**
 * Correspondência item ↔ filtro em missões.
 *
 * Três dos filtros **não** são status, e é por isso que a correspondência não
 * pode ser `item.uiStatus === filter`:
 *
 * - `ativas` cobre os status acionáveis (`available`, `progress` e `danger`)
 * - `ending` é janela de tempo (24h para o término)
 * - `recommended` é ranking por recompensa, e só vale para missão ativa
 * - `new` é recência (janela de 1h), eixo independente do progresso
 *
 * Módulo próprio, e não closure no hook: a suíte roda em `environment: 'node'` e
 * importar o hook arrastaria a cadeia de stores e de componentes.
 */
export const matchesMissionFilter = (
  item: MissionMatchable,
  filter: MissionFilterId
): boolean => {
  switch (filter) {
    case 'all':
      return true
    case 'new':
      return item.isNew
    case 'ativas':
      return isMissionActionable(item.uiStatus)
    case 'ending':
      return item.isEndingSoon
    case 'recommended':
      return item.isRecommended && isMissionActionable(item.uiStatus)
    default:
      return item.uiStatus === filter
  }
}
